import request from '@/utils/request'

const getSalesForceListByConuntry = () => {
  return request({
    path: `/v1/merchants/salesforce/list-by-country`,
    method: 'GET',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
  })
}

const createPromotion = (data) => {
  return request({
    path: `/v1/promotions`,
    method: 'POST',
    data,
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
  })
}

const updatePromotion = (promotionId, data) => {
  return request({
    path: `/v1/promotions/${promotionId}`,
    method: 'PUT',
    data,
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
  })
}

const deletePromotion = (promotionId) => {
  return request({
    path: `/v1/promotions/${promotionId}`,
    method: 'DELETE',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
  })
}

const terminatePromotion = (promotionId) => {
  return request({
    path: `/v1/promotions/${promotionId}/terminate`,
    method: 'PATCH',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
  })
}

const uploadPromotionImage = (promotionId, data) => {
  return request({
    path: `/v1/promotions/${promotionId}/images`,
    method: 'POST',
    data,
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
  })
}

const getPromotions = ({
  statusGroup = '',
  status = '',
  statusGroups,
  page = 1,
  pageSize = 10,
  fromDate,
  toDate,
  dealType,
  countries,
}) => {
  const statusGroupsParam =
    statusGroups || (statusGroup !== '0' ? statusGroup : undefined)

  return request({
    path: '/v1/promotions',
    method: 'GET',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
    data: {
      page,
      pageSize,
      status_groups: statusGroupsParam || undefined,
      include_stats: true,
      from_date: fromDate,
      to_date: toDate,
      deal_type: dealType,
      countries,
    },
  })
}

const getFarahPromotionsReport = ({ startDate, endDate, country }) => {
  return request({
    path: '/v1/promotions/reports',
    method: 'GET',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
    data: {
      start_date: startDate,
      end_date: endDate,
      country,
    },
  })
}

const getPromotionCategory = () => {
  return request({
    path: '/v1/promotions/category',
    method: 'GET',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
  })
}

const getPromotionDetail = (promotionId) => {
  return request({
    path: `/v1/promotions/${promotionId}`,
    method: 'GET',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
  })
}

const getPromotionStats = ({ promotionId, startDate, endDate }) => {
  return request({
    path: `v1/promotions/${promotionId}/reports`,
    method: 'GET',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
    data: {
      start_date: startDate,
      end_date: endDate,
    },
  })
}

const getOrderStats = ({ promotionId, startDate, endDate, segmentId }) => {
  return request({
    path: `/v1/promotions/${promotionId}/order-stats`,
    method: 'POST',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
    data: {
      start_date: startDate,
      end_date: endDate,
      segment_id: segmentId,
    },
  })
}

const getPromotionOnboardingStatus = () => {
  return request({
    path: '/v1/promotions/onboarding-status',
    method: 'GET',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
  })
}

const merchantPromotionOnboard = () => {
  return request({
    path: '/v1/promotions/onboard',
    method: 'POST',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
  })
}

const getPromotionInsights = ({ promotionId, startDate, endDate }) => {
  return request({
    path: `/v1/promotions/${promotionId}/insights`,
    method: 'GET',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
    data: {
      start_date: startDate,
      end_date: endDate,
    },
  })
}

const getPromotionMonthlyUsage = ({
  country,
  page,
  pageSize,
  redemptionMerchantId,
  isEmptySettlement = false,
  includeMerchant = false,
}) => {
  return request({
    path: `/v1/promotions/monthly-usage`,
    method: 'GET',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
    data: {
      country,
      page,
      pageSize,
      redemption_merchant_id: redemptionMerchantId,
      is_empty_settlement: isEmptySettlement,
      include_merchant: includeMerchant,
    },
  })
}

const getPromotionMonthlyUsageDetail = (promotionId) => {
  return request({
    path: `/v1/promotions/monthly-usage/${promotionId}`,
    method: 'GET',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
  })
}

const getPromotionMonthUsage = ({
  currency,
  redemptionMerchantId,
  monthOfYear,
}) => {
  return request({
    path: `/v1/promotions/month-usage`,
    method: 'GET',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
    data: {
      currency,
      redemption_merchant_id: redemptionMerchantId,
      month_of_year: monthOfYear,
    },
  })
}

const getPromotionSettlements = ({
  country,
  settlementMerchantId,
  page,
  pageSize,
}) => {
  return request({
    path: `/v1/promotions/settlements`,
    method: 'GET',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
    data: {
      country,
      settlement_merchant_id: settlementMerchantId,
      page,
      pageSize,
    },
  })
}

const getPromotionSettlementsDetail = (settlementId) => {
  return request({
    path: `/v1/promotions/settlements/${settlementId}`,
    method: 'GET',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
  })
}

const getPromotionSettlementsTransactions = (
  settlementId,
  { page, pageSize, types }
) => {
  return request({
    path: `/v1/promotions/settlements/${settlementId}/transactions`,
    method: 'GET',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
    data: {
      page,
      pageSize,
      types,
    },
  })
}

const exportPromotionSettlementsTransactions = (settlementId) => {
  return request(
    {
      path: `/v1/promotions/settlements/${settlementId}/transactions/export`,
      method: 'GET',
      customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
    },
    {
      responseType: 'blob',
      options: {
        camelizeRes: false,
      },
    }
  )
}

const exportPromotionSettlementsInvoice = (settlementId) => {
  return request({
    path: `/v1/promotions/settlements/${settlementId}/invoice`,
    method: 'GET',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
  })
}

const fileToRawBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => {
      const result = reader.result
      if (typeof result !== 'string') {
        reject(new TypeError('Unexpected file read result'))
        return
      }
      const base64 = result.includes(';base64,')
        ? result.split(';base64,')[1]
        : result
      resolve(base64)
    }
    reader.onerror = () => reject(reader.error)
    reader.readAsDataURL(file)
  })

const submitSettlementPaymentReference = async (settlementId, file) => {
  const filePayload = await fileToRawBase64(file)

  return request({
    path: `/v1/promotions/settlements/${settlementId}/bank-transfer`,
    method: 'PUT',
    data: { file: filePayload },
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
  })
}

const getPromotionSettlementPaymentMethod = () => {
  return request({
    path: '/v1/promotions/settlements/payment-method',
    method: 'GET',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
  })
}

const getPromotionMonthPromotionUsage = ({
  country,
  page,
  pageSize,
  monthOfYear,
  redemptionMerchantId,
}) => {
  return request({
    path: '/v1/promotions/month-promotion-usages',
    method: 'GET',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
    data: {
      country,
      page,
      pageSize,
      month_of_year: monthOfYear,
      redemption_merchant_id: redemptionMerchantId,
    },
  })
}

const getPromotionSalesReport = (promotionId) => {
  return request({
    path: `/v1/promotions/${promotionId}/sales-report`,
    method: 'GET',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
  })
}

export {
  getSalesForceListByConuntry,
  uploadPromotionImage,
  createPromotion,
  updatePromotion,
  deletePromotion,
  terminatePromotion,
  getPromotions,
  getPromotionCategory,
  getPromotionDetail,
  getFarahPromotionsReport,
  getPromotionStats,
  getOrderStats,
  getPromotionOnboardingStatus,
  merchantPromotionOnboard,
  getPromotionInsights,
  getPromotionMonthlyUsage,
  getPromotionMonthlyUsageDetail,
  getPromotionMonthUsage,
  getPromotionSettlements,
  getPromotionSettlementsDetail,
  getPromotionSettlementsTransactions,
  exportPromotionSettlementsTransactions,
  exportPromotionSettlementsInvoice,
  submitSettlementPaymentReference,
  getPromotionSettlementPaymentMethod,
  getPromotionMonthPromotionUsage,
  getPromotionSalesReport,
}
